import CustomButton from "shared/ui/CustomButton";
import Icon from "shared/ui/Icon";
import {useAuth} from "hooks/useAuth";
import StyledBadge from "../../../shared/ui/StyledBadge";
import {useNavigate} from "react-router-dom";


const NotificationsIcon = () => {
    const {user} = useAuth();
    const navigate = useNavigate();

    return (
        <StyledBadge badgeContent={user.notifications}>
            <CustomButton
                buttonType="icon"
                appearance="circle"
                bgcolor="white"
                borderColor={user.notifications ? "error.main" : ""}
                size="small"
                onClick={() => navigate("/mesaje")}
                icon={<Icon icon="fas bell-on" style={{fontSize: "1rem"}}/>}
                sxExtra={{fontSize: "1.25rem"}}
            />
        </StyledBadge>
    );
};

export default NotificationsIcon;
